export enum WalletDisplayButtonTestIds {
    BUTTON = 'wallet_button'
}